import { registerDecorator, ValidationArguments, ValidationOptions } from 'class-validator';
import { environment } from '../environments/environment';

const isValidHttpUrl = (string: string) => {
  const urlRegex = /^(http(s)?:\/\/.)[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)$/i;
  return urlRegex.test(string);
};

export default isValidHttpUrl;

export function IsValidTiktokUrl(validationOptions?: ValidationOptions) {
  return function (object: Object, propertyName: string) {
    registerDecorator({
      target: object.constructor,
      propertyName: propertyName,
      options: validationOptions,
      constraints: [],
      validator: {
        validate(value: any, args: ValidationArguments) {
          if (value === '') {
            return true;
          }

          const regex = /^https:\/\/[a-zA-Z]+\.tiktok\.com\/*/g;
          const matches = value.match(regex);

          return !(matches === null || matches.length === 0);
        }
      }
    });
  };
}

/**
 * Method to help determine if the user is on a team environment to adjust stuff like cookies
 * @returns
 */
export function isTeamEnvironment() {
  if (environment.env === 'ta01' || environment.env === 'tb01' || environment.env === 'tc01') {
    return true;
  }

  return false;
}

export function getQueryStringParam(queryString: string, paramName: string) {
  const params = new URLSearchParams(queryString);
  return params.get(paramName);
}

/**
 * @returns `paramName` out of `queryString` parsed as a `Number`. Returns null if the parameter does not exist or is not an integer.
 */
export function getQueryStringInteger(queryString: string, paramName: string) {
  const params = new URLSearchParams(queryString);
  const stringParam = params.get(paramName);
  const numberParam = Number.parseInt(stringParam, 10);
  return Number.isNaN(numberParam) ? null : numberParam;
}
